module.exports = __webpack_public_path__ + "img/user-head.bcab9c7d.png";